import NewsHeader from "../components/newsHeader";
import { useEffect, useState } from "react";
import { getNewsItems } from "../lib/firestoreContent";

const fallbackNewsImages = {
  "XploreStem Launches New Robotics Program": "/images/bootcamp2020.svg",
  "Strategic Partnership with Women in Engineering": "/images/women.svg",
  "Partnership with Women in Engineering": "/images/women.svg",
  "Calvary Arrows STEM Training Outreach": "/images/in Calvary Arrows.svg",
};

const fallbackNews = [
  {
    id: "news-1",
    title: "XploreStem Launches New Robotics Program",
    summary: "We are excited to announce a brand new 1-year online robotics bootcamp, proudly sponsored by XploreSTEMi with partners across Africa.",
    date: "Recent Update",
    imageUrl: "/images/bootcamp2020.svg",
  },
  {
    id: "news-2",
    title: "Partnership with Women in Engineering",
    summary: "We are pleased to announce our strategic partnership with Women in Engineering to equip and mentor the next generation of female innovators in STEM.",
    date: "16th September 2021",
    imageUrl: "/images/women.svg",
  },
  {
    id: "news-3",
    title: "Calvary Arrows STEM Training Outreach",
    summary: "Our hands-on robotics and programming workshop equipped secondary school students with vital technology skills and innovative mindsets.",
    date: "Past Event",
    imageUrl: "/images/in Calvary Arrows.svg",
  },
];

const News = () => {
    const [news, setNews] = useState(fallbackNews);
    const [newsState, setNewsState] = useState({ loading: true, error: "" });

    useEffect(() => {
      const loadNews = async () => {
        try {
          const items = await getNewsItems();
          if (Array.isArray(items) && items.length > 0) {
            setNews(items);
          }
          setNewsState({ loading: false, error: "" });
        } catch (error) {
          console.error("Unable to load news:", error);
          setNewsState({ loading: false, error: "" });
        }
      };

      loadNews();
    }, []);

    return (
      <>
        <div
          style={{
            backgroundImage: `linear-gradient(45deg, white, rgba(245, 245, 251, 1), rgba(224, 225, 244), rgba(230, 230, 247, 1), rgba(255, 217, 249), rgba(254, 236, 252), white) `,
          }}
        >
          <NewsHeader />
        </div>

        <div className="w-[90%] md:w-[80%] m-auto py-[50px]">
          <h1
            style={{ fontFamily: "'Clash Display', sans-serif", fontWeight: 550 }}
            className="text-center mb-8 text-[2.2rem] md:text-[2.6rem] text-dark"
          >
            Latest News & Announcements
          </h1>
          {newsState.loading ? (
            <p className="text-center text-[#4B4B4B]">Loading news…</p>
          ) : newsState.error ? (
            <p className="text-center text-red-600">{newsState.error}</p>
          ) : news.length === 0 ? (
            <p className="text-center text-[#4B4B4B]">News will appear here once published from the admin dashboard.</p>
          ) : (
            <div className="grid gap-8 md:grid-cols-2">
              {news.map((item) => {
                const imageUrl = item.imageUrl || fallbackNewsImages[item.title] || null;
                return (
                  <div key={item.id} className="rounded-xl bg-white p-6 text-left shadow-xl border border-slate-100 flex flex-col justify-between">
                    <div>
                      {imageUrl && (
                        <div className="mb-4 overflow-hidden rounded-lg bg-slate-50 flex items-center justify-center h-52">
                          <img src={imageUrl} alt={item.title} className="h-full w-full object-contain p-2" />
                        </div>
                      )}
                      <div className="flex items-center justify-between gap-2 mb-2">
                        <span className="text-xs font-semibold text-purple-600 uppercase tracking-wider">
                          {item.date || "Update"}
                        </span>
                      </div>
                      <h3 style={{ fontFamily: "'Clash Display', sans-serif" }} className="text-xl font-bold text-dark mb-2">
                        {item.title}
                      </h3>
                      <p style={{ fontFamily: "'Montserrat', sans-serif" }} className="text-[#4B4B4B] text-sm leading-relaxed break-words whitespace-pre-line">
                        {item.summary}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </>
    );
};

export default News;
